import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { DiscoveryRow as DiscoveryRowType } from '../../data/discoveryRowsData';
import { BookCatalogEntry } from '../../data/booksData';
import UnifiedBookCard from '../Books/UnifiedBookCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { ScrollableRow } from '../UI/ScrollableRow';
interface DiscoveryRowProps {
  row: DiscoveryRowType;
  books: BookCatalogEntry[];
}
const DiscoveryRow: React.FC<DiscoveryRowProps> = ({
  row,
  books
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  if (!books || books.length === 0) return null;
  return <section className={`py-8 ${dk.page}`} data-id="element-1732" data-mp="v7kt5tzilkoq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1733" data-mp="vays0s8yzbrf">
        <div className="flex items-end justify-between mb-6" data-id="element-1734" data-mp="2blkqqyaw0y8t">
          <div data-id="element-1735" data-mp="26oaouj6bau43">
            <h2 className={`text-2xl font-bold flex items-center ${dk.textHeading}`} data-id="element-1736" data-mp="26mr8ksknoj2b">
              {row.emoji && <span className="mr-3 text-2xl" data-id="element-1737" data-mp="30zhjontjh3wb">{row.emoji}</span>}
              <span className={row.accentColor} data-id="element-1738" data-mp="350kyd6zuotvy">{row.title}</span>
            </h2>
            {row.description && <p className={`mt-1 text-sm ${dk.textSecondary}`} data-id="element-1739" data-mp="3a1qrh5xfaj60">
                {row.description}
              </p>}
          </div>
          {row.linkTo && <Link to={row.linkTo} className={`font-medium flex items-center text-sm sm:text-base ${rt.accentLink}`} data-id="element-1740" data-mp="2hcjjlgc2wh83">
              View all
              <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-1741" data-mp="2ra7rz92lxn8q" />
            </Link>}
        </div>

        <ScrollableRow data-id="element-1742" data-mp="2w0een3dk6xoc">
          {books.map(book => <div key={book.id} className="flex-shrink-0 w-[160px] sm:w-[200px] snap-start" data-id="element-1743" data-mp="2w1z9yv7p6kn9">
              <UnifiedBookCard book={book} data-id="element-1744" data-mp="23k3od1pf5nhq" />
            </div>)}
        </ScrollableRow>
      </div>
    </section>;
};
export default DiscoveryRow;